"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-eight/sections/serviceSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type ServiceSectionCounterZoomInsItem = {
    key: Key | null | undefined;
    /** Detected variants: "+" | "K+" | "K" | "%" */
    h40Text: ReactNode;
    /** Detected variants: "display-6 primary-count" | "display-6 secondary-count" */
    className: string;
    /** Detected variants: "12" | "25" | "30" | "98" */
    span0Text: ReactNode;
    /** Detected variants: "Years Experience" | "Patients Treated" | "Success Rate" | "Cardiology Services" */
    p0Text: ReactNode;
    /** Detected variants: "counter-item text-center wow zoomIn" */
    divClassName?: string;
    /** Detected variants: "1s" */
    dataWowDuration?: string;
    /** Detected variants: "count-digit counter-loaded" */
    span0ClassName?: string;
};
export type HomeEightServiceSectionGeneratedProps = {
    divH40H4Props?: Partial<ComponentProps<"h4">> | ((item: ServiceSectionCounterZoomInsItem) => Partial<ComponentProps<"h4">>);
    /** Default: "1s" */
    sectionDataWowDuration?: string;
    /** Default: "Advanced Vision" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "banner-icon" */
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-six-img2.jpg" */
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Care Solutions" */
    sectionDiv0Div0H20Span1SpanText?: ReactNode;
    sectionDiv1Div0Div0ClassName?: string;
    serviceSectionCounterZoomIns: ServiceSectionCounterZoomInsItem[];
    serviceSectionCounterZoomInsItemWrapper?: (item: ServiceSectionCounterZoomInsItem, content: ReactNode) => ReactNode;
    serviceSectionCounterZoomInsRenderer?: (defaultNode: ReactNode) => ReactNode;
    serviceSectionCounterZoomInsH4Visible?: boolean;
    serviceSectionCounterZoomInsH4Renderer?: (item: ServiceSectionCounterZoomInsItem, defaultNode: ReactNode) => ReactNode;
    serviceSectionCounterZoomInsH4Props?: Partial<ComponentProps<"h4">> | ((item: ServiceSectionCounterZoomInsItem) => Partial<ComponentProps<"h4">>);
};

const HomeEightServiceSectionGenerated: FC<HomeEightServiceSectionGeneratedProps> = ({
    sectionDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "Advanced Vision",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageAlt = "banner-icon",
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/banner/banner-six-img2.jpg",
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageProps,
    sectionDiv0Div0H20Span1SpanText = "Care Solutions",
    divH40H4Props,
    sectionDiv1Div0Div0ClassName,
    serviceSectionCounterZoomIns,
    serviceSectionCounterZoomInsItemWrapper,
    serviceSectionCounterZoomInsRenderer,
    serviceSectionCounterZoomInsH4Visible,
    serviceSectionCounterZoomInsH4Renderer,
    serviceSectionCounterZoomInsH4Props,
}) => {
    return (
        <section className="services-section-eight section wow fadeInUp" data-wow-duration={sectionDataWowDuration}>
            <div className="container-fluid">
                <div className="section-header section-header-eight text-center">
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {sectionDiv0Div0H20H2Text}
                            <br />
                            {" "}
                            <span className="img-container">
                                {renderNode(sectionDiv0Div0H20Span0ImageWithBasePath0ImageVisible, sectionDiv0Div0H20Span0ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div0H20Span0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0H20Span0ImageWithBasePath0ImageAlt} className="img-fluid img-one" {...(sectionDiv0Div0H20Span0ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                            </span>
                            <span className="text-gradient">{sectionDiv0Div0H20Span1SpanText}</span>
                        </h2>
                    ))}
                </div>
                <div data-template-tag="ServicesSliderEight" />
            </div>
            <div className="container">
                <div className="testimonial-counter testimonial-counter-eight section pb-0">
                    <div className={sectionDiv1Div0Div0ClassName ?? "row row-cols-2 row-cols-sm-2 row-cols-md-4 row-cols-lg-4 g-4"}>
                        {renderCollectionNode(
                            serviceSectionCounterZoomIns,
                            (item: ServiceSectionCounterZoomInsItem) => (
                                <div className={item.divClassName ?? "counter-item text-center wow zoomIn"} data-wow-duration={item.dataWowDuration ?? "1s"} key={item.key}>
                                    {renderItemNode(serviceSectionCounterZoomInsH4Visible, serviceSectionCounterZoomInsH4Renderer, item, (
                                        <h4 className={item.className} {...(typeof serviceSectionCounterZoomInsH4Props === "function" ? serviceSectionCounterZoomInsH4Props(item) : (serviceSectionCounterZoomInsH4Props ?? {}))} {...(typeof divH40H4Props === "function" ? divH40H4Props(item) : (divH40H4Props ?? {}))}>
                                            <span className={item.span0ClassName ?? "count-digit counter-loaded"}>{item.span0Text}</span>
                                            {item.h40Text}
                                        </h4>
                                    ))}
                                    <p>{item.p0Text}</p>
                                </div>
                            ),
                            serviceSectionCounterZoomInsItemWrapper,
                            serviceSectionCounterZoomInsRenderer
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeEightServiceSectionGenerated;
